// Single source of truth for the site's indexable URLs.
// Consumed by scripts/generate-sitemap.ts and scripts/prerender.ts.
import { NEXT_COHORT_PATH } from "./cohorts";
import { MEMBER_SHOWCASE_FUNCTION_PATHS } from "./member-showcase";
import { WORKSHOP_INDEXABLE_PATHS } from "./workshops";

export const MEMBER_SHOWCASE_PATH = "/member-showcase" as const;
export const LEGACY_FROM_THE_LAB_PATH = "/from-the-lab" as const;

const STATIC_ROUTE_PATHS = [
  "/",
  "/curriculum",
  "/membership",
  NEXT_COHORT_PATH,
  "/workshops",
  MEMBER_SHOWCASE_PATH,
  "/about-us",
  "/team-training",
  "/faq",
  "/contact",
] as const;

export const INDEXABLE_ROUTE_PATHS: readonly string[] = [
  ...STATIC_ROUTE_PATHS,
  ...WORKSHOP_INDEXABLE_PATHS,
  ...MEMBER_SHOWCASE_FUNCTION_PATHS,
];
